<template>
  <div class="chat-npc-box" :class="{ show: show_dialogue || phoneMode }">
    <div class="dialogue-box fadeIn" :class="{ hide: loading }" ref="dialogueBox">
      <div class="dialogue" ref="dialogue">
        <div class="messages" :class="item.role" :ref="'msg_' + i" v-for="(item, i) of  messages" :key="i">
          <div class="content">{{ item.content }}</div>
        </div>
      </div>
      <div class="dialogue-bottom" v-if="show_dialogue || phoneMode">
        <div class="dialogue-notice" :class="{ show: isAsking || isRecording }">
          <div v-if="isAsking">{{ loaddingText }}</div>
          <div class="voice-notice" v-else-if="isRecording">请使用麦克风进行语音识别（{{ recordTime }}s）</div>
          <div class="stop-box" v-if="isAnswering" @click="stopPlay()">
            <svg class="icon-svg">
              <use xlink:href="#icon-stop" />
            </svg>
            <span>停止</span>
          </div>
        </div>

        <div class="input-box">
          <a-textarea class="textarea" :class="{ stopInput: isRecording || isAsking || isAnswering }"
            v-model:value="question" placeholder="请输入内容..." :rows="3" @keyup.enter="askQuestion()" />
          <div class="input-right">
            <template v-if="canUseVoice">
              <a-tooltip title="开始语音识别" v-if="!isRecording">
                <svg class="icon-svg" :class="{ disabled: isAsking || isAnswering }" @click="startRecording()">
                  <use xlink:href="#icon-mic-on" />
                </svg>
              </a-tooltip>
              <a-tooltip title="停止语音识别" v-else>
                <svg class="icon-svg" @click="stopRecording()">
                  <use xlink:href="#icon-mic-off" />
                </svg>
              </a-tooltip>
            </template>

            <a-tooltip title="发送提问">
              <svg class="icon-svg icon-push" :class="{ disabled: isAsking || isAnswering }" @click="askQuestion()"
                v-if="!isRecording">
                <use xlink:href="#icon-push" />
              </svg>
            </a-tooltip>
          </div>
        </div>
      </div>
    </div>
    <div class="chat-npc" ref="npc"></div>

    <div class="voice" @click="startRecording()" v-if="canUseVoice">
      <svg class="icon-svg voice-icon">
        <use xlink:href="#icon-record-sound" />
      </svg>
    </div>
  </div>
</template>

<script>
import { BabylonChatNpc } from "../../utils/babylonChatNpc";
import { Modal } from 'ant-design-vue';
import crypto from 'crypto';

export default {
  name: "chat-npc",
  data() {
    return {
      loading: true,
      show_dialogue: false,
      scrolling: false,

      token: '',
      question: '',
      answer: '',
      classId: '',
      messages: [
        { "role": "system", "content": "你将扮演一个乐于助人的助理" },
        { "role": "assistant", "content": "你好！我是元小习，你的AI助教，有什么问题要问吗？" },
      ],

      isAsking: false,
      isAnswering: false,

      //
      canUseVoiceList: ['43288470-82be-11ee-9c31-d93af03cea99', 'f04018b0-88d8-11ee-bd15-a3fe7f6ac316', '0d2a6e80-b99e-11ee-a1d8-3f479df4d981'],

      canUseVoice: false,
      recordTime: 60,
      recordTimer: null,
      isRecording: false,
      isNeedRead: false,
      isStopPlay: false,
      currentVoice: null,
      params: {
        secretid: '',
        secretkey: '',
        appid: '',
        engine_model_type: '16k_zh-PY', // 因为内置WebRecorder采样16k的数据，所以参数 engineModelType 需要选择16k的引擎，为 '16k_zh'
      },
      webAudioSpeechRecognizer: null,
      isTeacherma: false,
      loaddingText: '元小习努力思考中...',
    }
  },
  props: {
    phoneMode: Boolean,
    roleKeyword: String
  },
  async mounted() {
    let { userInfo, currentClass } = this.$store.state;
    this.token = userInfo.token;
    this.classId = currentClass.PK_ClassGuid;
    this.isTeacherma = this.classId === '55283e50-06b6-11ef-8ff0-bdbc3620a711'

    if(this.canUseVoiceList.includes(this.classId)) this.canUseVoice = true;
    let url = `https://file.lessonplan.cn/BABYLON/chatnpc.glb`
    if(this.isTeacherma) {
      //url = 'https://file.lessonplan.cn/BABYLON/teacherma.glb'
      this.messages[1] = { "role": "assistant", "content": "您好，我是主编马老师的AI助教，请问有什么可以帮您？" }
      this.loaddingText = 'AI助教努力思考中...'
    }
    if(this.roleKeyword) {
      this.messages[0].content = `我想让你扮演一名老师。我将提供一些含有${this.roleKeyword}概念相关的问题，你的工作是用易于理解的术语、类比和案例来解释它们（这很重要）。要求你在本次对话过程中，每次回答，都只回答与${this.roleKeyword}概念直接相关的问题，如果我问了其它领域，都请严格遵循一律不回答的原则（这很重要），并回复：“抱歉！我不能回答与本教材无关的问题”。`;
    }
    this.$nextTick(async () => {
      //初始化
      let npc_el = this.$refs.npc;
      let config = {
        url: url,
        debug: false
      }
      // const teacherma = {
      //   alpha: 1.558,
      //   beta: 1.51,
      //   radius: 1.24,
      //   target: [-0.0127, 0.6147, -0.0615],
      //   hdr: 'https://file.lessonplan.cn/BABYLON/studio.env'
      // }
      if(this.isTeacherma) {
        // config = { ...config, ...teacherma }
      }
      this.babylonChatNpc = new BabylonChatNpc(npc_el, config)
      await this.babylonChatNpc.init();
      // if(!this.isTeacherma) {
      this.babylonChatNpc.playAnimation('O_CH_LittleWitch|Hello01|Base Layer', false)
      // }
      // else {
      //   this.babylonChatNpc.playAnimation('animation0', false)
      // }
      setTimeout(() => {
        this.loading = false;
      }, 1000);
      //监听点击
      npc_el.addEventListener('click', () => {
        //console.log(this.babylonChatNpc.cameraAttribute())
        this.show_dialogue = !this.show_dialogue;
        // if(!this.isTeacherma) {
        this.babylonChatNpc.playAnimation('O_CH_LittleWitch|Hello01|Base Layer', false)
        // }
        // else {
        //   this.babylonChatNpc.playAnimation('animation0', false)
        // }
      })

      //监听对话框外部点击
      window.addEventListener('mousedown', e => { this.hideDialogue(e) })
      //监听对话框外部点击
      window.addEventListener('blur', e => {
        if(document.activeElement && document.activeElement.nodeName.toLocaleLowerCase() == 'iframe') {
          this.show_dialogue = false;
        }
      })

      this.dialogueScroll();
    })

    if(this.canUseVoice) this.getTXCloudInfo();
  },
  methods: {
    //问问题
    async askQuestion() {
      this.isStopPlay = false;
      let question = this.question;
      let messages = this.messages;

      if(this.isAsking) return;
      if(!question) return this.$message.warning('请先输入问题');
      this.messages.push({ role: 'user', content: question });
      this.question = '';
      this.$nextTick(async () => { this.scrollBottom() });

      this.isAsking = true;
      /////整个回答
      this.$nextTick(async () => { this.dialogueScroll() })

      try {
        const res = await this.$api.unifydata.getChat({ messages, textbookId: this.classId });
        if(res.statusCode != 200) throw new Error(res.message);

        const content = res.data[0].content;
        if(this.isNeedRead) this.startSynthesis(content);
        else this.typingEffect(content);
      }
      catch(error) {
        this.canUseVoice = false;
        Modal.warning({
          title: '很抱歉，您今日的提问次数已达到上限',
        })

        setTimeout(() => {
          this.stopPlay();
          this.show_dialogue = false;
        }, 3000);
      }
    },
    //打字机效果
    async typingEffect(content) {
      this.isAnswering = true;
      this.messages.push({ "role": "assistant", "content": "" });
      let answer = '';

      const speed = this.isNeedRead ? 200 : 50;
      for(const i in content) {
        if(this.isStopPlay) break;
        await new Promise(resolve => {
          setTimeout(() => {
            answer += `${content[i]}`;
            this.messages[this.messages.length - 1].content = answer;
            this.scrollBottom()

            //回答完成
            if(i == content.length - 1) {
              this.isAnswering = false;
              this.isAsking = false;
              // if(!this.isTeacherma) {
              this.babylonChatNpc.playAnimation('O_CH_LittleWitch|Tutorial_Clap02|Base Layer', false)
              // }
              // else {
              this.messages[this.messages.length - 1].content += '\n以上内容供参考。'
              //   this.babylonChatNpc.playAnimation('animation0', false)
              // }
            }

            resolve();
          }, speed);
        });
      }
    },
    //对话滚动
    dialogueScroll() {
      let num = this.messages.length - 1;
      let npc_el = this.$refs[`msg_${num}`];

      if(npc_el) {
        let scrollTop = npc_el.offsetTop - 13;
        $(`.dialogue`).animate({ scrollTop }, 300);
      }
    },
    //对话滚动
    scrollBottom() {
      if(this.scrolling) return;
      this.scrolling = true;
      let scrollTop = $('.dialogue').prop("scrollHeight");
      $(`.dialogue`).animate({ scrollTop }, 300);
      setTimeout(() => { this.scrolling = false }, 300);
    },
    //隐藏对话框
    hideDialogue(e) {
      // 获取被点击的元素
      const clickedEl = e.target;
      const dialogueBox = this.$refs.dialogueBox;
      if(!clickedEl || !dialogueBox) return;
      if(!dialogueBox.contains(clickedEl)) this.show_dialogue = false;
    },

    /////////////////////////////////语音识别
    async getTXCloudInfo() {
      const res = await this.$api.tts.getTXCloudInfo(this.token);
      if(res.status != 1) return;
      const { encryptedSecretInfo } = res.data;
      if(!encryptedSecretInfo) return;
      const { encryptedData, iv } = encryptedSecretInfo;
      if(!encryptedData || !iv) return;
      const { secretId, secretKey, appId } = JSON.parse(this.decrypt(encryptedData, iv));

      if(!secretId || !secretKey || !appId) return;

      this.params.secretid = secretId;
      this.params.secretkey = secretKey;
      this.params.appid = appId;
    },
    decrypt(encryptedData, iv) {
      const algorithm = 'aes-256-ctr';
      const encryptionKey = 'b5f15d792666eda78f14d2bec1636333';
      const decipher = crypto.createDecipheriv(algorithm, encryptionKey, Buffer.from(iv, 'hex'));
      let decrypted = decipher.update(encryptedData, 'hex', 'utf8');
      decrypted += decipher.final('utf8');
      return decrypted;
    },

    //开始识别
    async startRecording() {
      if(this.isRecording) return;

      this.isRecording = true;
      this.isNeedRead = true;
      this.show_dialogue = true;
      this.question = '';

      const webAudioSpeechRecognizer = new WebAudioSpeechRecognizer(this.params);
      // 开始识别
      webAudioSpeechRecognizer.OnRecognitionStart = (res) => {
        this.recordTime = 60;
        this.recordTimer = setInterval(() => {
          this.recordTime--;
          if(this.recordTime <= 0) {
            this.stopRecording();
          }
        }, 1000);
      };
      // 识别变化时
      webAudioSpeechRecognizer.OnRecognitionResultChange = (res) => {
        if(res.code == 0 && res.result) {
          this.question = res.result.voice_text_str;
        }
      };
      // // 识别结束
      // webAudioSpeechRecognizer.OnRecognitionComplete = (res) => {
      //   console.log('识别结束', res);
      // };

      webAudioSpeechRecognizer.start();
      this.webAudioSpeechRecognizer = webAudioSpeechRecognizer;
    },
    //停止识别
    stopRecording() {
      if(!this.webAudioSpeechRecognizer) return;

      clearInterval(this.recordTimer);
      this.isRecording = false;
      this.webAudioSpeechRecognizer.stop();
      this.webAudioSpeechRecognizer = null;

      if(this.question) {
        this.askQuestion()
      }
    },
    /////////////////////////////////语音合成
    async startSynthesis(text) {
      const parts = this.splitText(text);

      // 依次处理每个部分
      const audios = []
      for(const part of parts) {
        const audio = await this.$api.tts.TTS(part);
        audios.push(audio);
      }

      // 预加载音频
      const audioEls = [];
      for(const audio of audios) {
        const audioEl = new Audio(audio);
        audioEl.load();
        audioEls.push(audioEl);
      }

      this.typingEffect(text);
      // 依次播放每个音频
      for(const audioEl of audioEls) {
        if(this.isStopPlay) break;
        this.currentVoice = audioEl;
        await audioEl.play();
        await new Promise(resolve => {
          audioEl.onended = resolve;
        });
      }

      this.isNeedRead = false;
    },
    //分割文本
    splitText(text) {
      const maxCharsEnglish = 500;
      const maxCharsChinese = 150;
      const parts = [];

      let start = 0;
      while(start < text.length) {
        let end = start + maxCharsEnglish;

        // 如果文本包含中文，使用中文的最大长度
        if(/[\u4e00-\u9fa5]/.test(text.slice(start, end))) {
          end = start + maxCharsChinese;
        }

        // 在达到最大字符限制之前查找句子的结束
        for(let i = end; i > start; i--) {
          if(/[\u3002\uff1f\uff01\uff1b\uff1a]/.test(text[i])) {
            end = i + 1;
            break;
          }
        }
        parts.push(text.slice(start, end).trim());
        start = end;
      }

      return parts;
    },
    //停止打字机和语音播放
    stopPlay() {
      this.isStopPlay = true;
      this.isAnswering = false;
      this.isAsking = false;
      if(this.currentVoice) this.currentVoice.pause();
      // if(!this.isTeacherma) {
      this.babylonChatNpc.playAnimation('O_CH_LittleWitch|Tutorial_Clap02|Base Layer', false)
      // }
      // else {
      //   this.babylonChatNpc.playAnimation('animation0', false)
      // }
    }
  },
  beforeUnmount() {
    window.removeEventListener('mousedown', e => { this.hideDialogue(e) });
  }
};
</script>

<style scoped lang="scss">
@import "./chat-npc.scss";
</style>